import page from '@/components/page/page';
import officialPage from '@/components/page/official-page';
import Vue from 'vue';

Vue.component('ps-page', page);
Vue.component('of-page', officialPage);